// extracted by css-extract-rspack-plugin
export default {"typeContainer":"TypesSection-module__typeContainer__qpKTxhK"};